import TaskDetails from '@/common/containers/TaskDetails/TaskDetails';

export default TaskDetails;
